import { render, staticRenderFns } from "./OneTicketPass.vue?vue&type=template&id=4a87c0aa&scoped=true"
import script from "./OneTicketPass.vue?vue&type=script&lang=js"
export * from "./OneTicketPass.vue?vue&type=script&lang=js"
import style0 from "./OneTicketPass.vue?vue&type=style&index=0&id=4a87c0aa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a87c0aa",
  null
  
)

export default component.exports